import styled from "@emotion/styled";
import Button, { ButtonProps } from "@/components/Button";

export const ModalWrapper = styled.div`
	background-color: #fff;
	border-radius: 10px;
	box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.1);
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	min-width: 550px;
	padding: 24px;
`;

export const ModalTitle = styled.p`
	font-size: 32px;
	line-height: 48px;
	color: #000;
	margin-bottom: 38px;
	font-weight: bold;
`;

export const ModalButtonWrapper = styled.div`
	margin-top: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
`;

export const ModalButton = styled(Button)<ButtonProps>`
	width: 90px;
	height: 40px;
	color: #fff;
	font-weight: bold;
`;

export const ModalCancelButton = styled(ModalButton)`
	border: 1px solid #ccc;
	color: #747474;
	margin-right: 6px;
`;
